<div class="maintenance-div">
    <h1 class="opacity-08">
      <strong>{{ Localization.MaintenanceHeader | translate}}</strong>
    </h1>
    <br />
    <i class="fa fa-gears opacity-06 icon-large" aria-hidden="true"></i>
    <br />
    <h3 class="opacity-05">{{ Localization.MaintenanceDetails | translate}}</h3>
    <br />
</div>
